import flatpickr from 'flatpickr';
import { French } from 'flatpickr/dist/l10n/fr.js';
import 'flatpickr/dist/flatpickr.css';

const formDateLocale = {
	...French,
	firstDayOfWeek: 1,
	weekdays: {
		...French.weekdays,
		shorthand: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
	}
};

$(document).ready(function() {
	$('[data-frm-date]').each(function() {
		const input = this;

		if (input._flatpickr) {
			return;
		}

		flatpickr(input, {
			locale: formDateLocale,
			monthSelectorType: 'static',
			altInput: true,
			altFormat: 'd/m/Y',
			allowInput: false,
			dateFormat: input.dataset.dateFormat || 'd F Y',
			minDate: input.dataset.minDate || null,
			maxDate: input.dataset.maxDate || null,
			disableMobile: true
		});
	});
});
